import commonMapping from "@/mapping/common";
const loginreq_list = [
  {
    id: "loginreq",
    value: "pppoe",
    config: "yes",
    label: "yes_mark",
  },
  {
    id: "no_loginreq",
    value: "dhcp",
    config: "no",
    label: "no_mark",
  },
];

const wan_assign_list = [
  {
    id: "wan_assign_dhcp",
    value: "dhcp",
    config: "0",
    label: "basic_int_autoip",
  },
  {
    id: "wan_assign_static",
    value: "static",
    config: "1",
    label: "basic_int_static_ip",
  },
];

const dns_assign_list = [
  {
    id: "dns_assign_auto",
    value: "0",
    config: "0",
    label: "basic_int_autodns",
  },
  {
    id: "dns_assign_static",
    value: "1",
    config: "1",
    label: "basic_int_these",
  },
];

const pptp_dns_assign_list = [
  {
    id: "pptp_dns_assign_auto",
    value: "0",
    config: "0",
    label: "basic_int_autodns",
  },
  {
    id: "pptp_dns_assign_static",
    value: "1",
    config: "1",
    label: "basic_int_these",
  },
];

const mac_assign_list = [
  {
    id: "mac_assign_default",
    value: "0",
    config: "default",
    label: "basic_int_default_mac",
  },
  {
    id: "mac_assign_computer",
    value: "1",
    config: "computer",
    label: "basic_int_computer_mac",
  },
  {
    id: "mac_assign_define",
    value: "2",
    config: "fixed",
    label: "basic_int_this_mac",
  },
];

const preference_list = [
  {
    id: "internet_port1",
    value: "0",
    config: "internet",
    label: "wan_port",
  },
  {
    id: "sfp_port1",
    value: "1",
    config: "sfp",
    label: "wan_lan_spf",
  },
  {
    id: "5g_port1",
    value: "2",
    config: "5g",
    label: "5g_ether_port",
  },
];

const service_list = [
  {
    value: "PPTP",
    config: "pptp",
    label: "PPTP",
  },
  {
    value: "L2TP",
    config: "l2tp",
    label: "L2TP",
  },
  {
    value: "PPPoE",
    config: "pppoe",
    label: "PPPoE",
  },
  {
    value: "Multiple PPPoE",
    config: "mulpppoe",
    label: "basic_intserv_mulpppoe",
  },
  {
    value: "Orange PPPoE",
    config: "orange_france_pppoe",
    label: "orange_pppoe",
  },
  {
    value: "Orange DHCP",
    config: "orange_france_dhcp",
    label: "orange_dhcp",
  },
  {
    value: "Movistar Spain PPPoE",
    config: "movistar_spain_pppoe",
    label: "movi_spain_dhcp",
  },
  {
    value: "Orange Spain DHCP",
    config: "orange_spain_dhcp",
    label: "orange_spain_dhcp",
  },
  {
    value: "Vodafone Spain PPPoE",
    config: "vodafone_spain_pppoe",
    label: "voda_spain_dhcp",
  },
  {
    value: "SingTel Singapore DHCP",
    config: "singtel_singapore_dhcp",
    label: "singtel_singa_dhcp",
  },
  {
    value: "Unifi Malaysia DHCP",
    config: "unifi_malaysia_dhcp",
    label: "unifi_malaysia_dhcp",
  },
  {
    value: "Maxis Malaysia DHCP",
    config: "maxis_malaysia_dhcp",
    label: "maxis_malaysia_dhcp",
  },
];

const conn_mode_list = [
  {
    value: "Always On",
    config: "always_on",
    label: "basic_mode_always",
  },
  {
    value: "Dial on Demand",
    config: "dial_on_demand",
    label: "basic_mode_dial",
  },
  {
    value: "Manually Connect",
    config: "manual",
    label: "basic_mode_manual",
  },
];

const pppoe_wan_assign = [
  {
    id: "wan_assign_dynamic",
    value: "Dynamic",
    config: "0",
    label: "basic_int_autoip",
  },
  {
    id: "wan_assign_fixed",
    value: "Fixed",
    config: "1",
    label: "basic_int_static_ip",
  },
];

const auto_conn_time_list = [];
for (let i = 1; i <= 48; i++) {
  const item = { value: i.toString(), config: i - 1, label: "" };
  let label = "";
  const hour = Math.floor((i - 1) / 2);
  label = hour < 10 ? "0" + hour.toString() : hour.toString();
  if ((i - 1) % 2 === 0) {
    label += ":00";
  } else {
    label += ":30";
  }
  item.label = label;
  auto_conn_time_list.push(item);
}

const aftr_ipv6_list = [
  {
    id: "auto_aftr_ipv6",
    value: "0",
    config: "0",
    label: "ipv6_auto_config",
  },
  {
    id: "manual_aftr_ipv6",
    value: "1",
    config: "1",
    label: "manual_config",
  },
];

const session1_wan_assign = [
  {
    id: "WANAssign_ip",
    value: "0",
    config: "0",
    label: "basic_int_autoip",
  },
  {
    id: "WANAssign_st",
    value: "1",
    config: "1",
    label: "basic_int_static_ip",
  },
];

const session1_dns_assign_list = [
  {
    id: "DNSAssign_dn",
    value: "0",
    config: "0",
    label: "basic_int_autodns",
  },
  {
    id: "DNSAssign_th",
    value: "1",
    config: "1",
    label: "basic_int_these",
  },
];

const session2_enable_list = [
  {
    id: "enable_session2_dis",
    value: "0",
    config: "0",
    label: "pppoe2_disable",
  },
  {
    id: "enable_session2_en",
    value: "1",
    config: "1",
    label: "pppoe2_enable",
  },
];

const pppoe2_sessionList = [
  { value: "0", label: "pppoe2_west", config: "0" },
  { value: "1", label: "pppoe2_east", config: "1" },
  { value: "2", label: "pppoe2_other", config: "2" },
];

const session2_wan_assign = [
  {
    id: "WANAssign2_ip",
    value: "0",
    config: "0",
    label: "basic_int_autoip",
  },
  {
    id: "WANAssign2_st",
    value: "1",
    config: "1",
    label: "basic_int_static_ip",
  },
];

const session2_dns_assign_list = [
  {
    id: "DNSAssign2_au",
    value: "0",
    config: "0",
    label: "basic_int_autodns",
  },
  {
    id: "DNSAssign2_th",
    value: "1",
    config: "1",
    label: "basic_int_these",
  },
];

const session2_policyList = [
  { value: "0", label: "pppoe2_domain_name", config: "domain" },
  { value: "1", label: "pppoe2_ip_protocol", config: "ip_proto" },
  { value: "2", label: "pppoe2_port_protocol", config: "port_proto" },
];

const session2_protocolList = [
  { value: "TCP", label: "block_ser_setup_tcp", config: "TCP" },
  { value: "UDP", label: "block_ser_setup_udp", config: "UDP" },
  { value: "TCP/UDP", label: "block_ser_setup_tcp_udp", config: "TCP_UDP" },
];

export const internet = {
  loginreq: loginreq_list,
  preference: preference_list,
  service: service_list,
  "ether.fixed_dns_enable": dns_assign_list,
  "ether.fixed_ip_enable": wan_assign_list,
  "ether.mac_addr_assign_type": mac_assign_list,
  "ether.enable_ds_lite": commonMapping.intToBoolean,
  "ether.enable_nd_proxy": commonMapping.intToBoolean,
  "ether.aftr_ipv6": aftr_ipv6_list,
  "pppoe.conn_mode": conn_mode_list,
  "pppoe.fixed_dns_enable": dns_assign_list,
  "pppoe.fixed_ip_enable": pppoe_wan_assign,
  "pppoe.mac_addr_assign_type": mac_assign_list,
  "pppoe.auto_reset_time": auto_conn_time_list,
  "pppoe.auto_reset_enable": commonMapping.intToBoolean,
  "pppoe.enable_ds_lite": commonMapping.intToBoolean,
  "pppoe.enable_nd_proxy": commonMapping.intToBoolean,
  "pppoe.aftr_ipv6": aftr_ipv6_list,
  "mulpppoe.conn_mode": conn_mode_list,
  "mulpppoe.session1_fixed_dns_enable": session1_dns_assign_list,
  "mulpppoe.session1_fixed_ip_enable": session1_wan_assign,
  "mulpppoe.session2_enable": session2_enable_list,
  "mulpppoe.session2_fixed_dns_enable": session2_dns_assign_list,
  "mulpppoe.session2_fixed_ip_enable": session2_wan_assign,
  "mulpppoe.session2_conn_area": pppoe2_sessionList,
  "mulpppoe.session2_policy": session2_policyList,
  "mulpppoe.session2_protocol": session2_protocolList,
  "pptp.conn_mode": conn_mode_list,
  "pptp.auto_reset_time": auto_conn_time_list,
  "pptp.auto_reset_enable": commonMapping.intToBoolean,
  "pptp.fixed_dns_enable": pptp_dns_assign_list,
  "pptp.mac_addr_assign_type": mac_assign_list,
  "l2tp.conn_mode": conn_mode_list,
  "l2tp.auto_reset_time": auto_conn_time_list,
  "l2tp.auto_reset_enable": commonMapping.intToBoolean,
  "l2tp.fixed_dns_enable": dns_assign_list,
  "l2tp.mac_addr_assign_type": mac_assign_list,
  "orange_france_pppoe.conn_mode": conn_mode_list,
  "orange_france_pppoe.mac_addr_assign_type": mac_assign_list,
  "orange_france_dhcp.mac_addr_assign_type": mac_assign_list,
  "orange_france_dhcp.iptv_enable": commonMapping.intToBoolean,
  "movistar_spain_pppoe.conn_mode": conn_mode_list,
  "movistar_spain_pppoe.mac_addr_assign_type": mac_assign_list,
  "movistar_spain_pppoe.iptv_enable": commonMapping.intToBoolean,
  "orange_spain_dhcp.mac_addr_assign_type": mac_assign_list,
  "orange_spain_dhcp.iptv_enable": commonMapping.intToBoolean,
  "vodafone_spain_pppoe.conn_mode": conn_mode_list,
  "vodafone_spain_pppoe.mac_addr_assign_type": mac_assign_list,
  "vodafone_spain_pppoe.iptv_enable": commonMapping.intToBoolean,
  "singtel_singapore_dhcp.mac_addr_assign_type": mac_assign_list,
  "singtel_singapore_dhcp.iptv_enable": commonMapping.intToBoolean,
  "unifi_malaysia_dhcp.mac_addr_assign_type": mac_assign_list,
  "unifi_malaysia_dhcp.iptv_enable": commonMapping.intToBoolean,
  "maxis_malaysia_dhcp.mac_addr_assign_type": mac_assign_list,
  "maxis_malaysia_dhcp.iptv_enable": commonMapping.intToBoolean,
};

export default internet;
